import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { Row, Col } from "reactstrap";
import * as Scroll from "react-scroll";
import { MESSAGE_CHAT_CONTAINER,validateTokenStorage } from "./../../Constants/Util";
import StoreContext from "./../../../Store/Context";
import { getDocList, getMessagesStudent, postMessagesStudent,validateLogin,fetchtMessagesForumStudent,postMessagesForumStudent } from "./../../Constants/Services";
import "./../../../www/css/Chat.css";
import {IMessagePerson,IMessageStudent,IPersonSelected} from './../../Constants/Interfaces';
import moment from "moment";
let scroll = Scroll.animateScroll;

interface IMessageState {
  dataPerson: IMessagePerson[];
  personForm: IPersonSelected;
  dataMessages: IMessageStudent[];
  loading: boolean;
  formMessages: {
    msg_remitente: string;
    msg_destinatario: string;
    msg_desc: string;
    msg_time: string;
  };
  isOpenMessage: boolean;
  isOpenForum:boolean;
 
}

class Messages extends Component<RouteComponentProps<{}>, IMessageState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      dataPerson: [],
      personForm: {
        per_id: "",
        per_name: "",
      },
      dataMessages: [],
      loading: false,
      formMessages: {
        msg_remitente: "",
        msg_destinatario: "",
        msg_desc: "",
        msg_time: "",
      },
      isOpenMessage: false,
      isOpenForum:false,

    };
    this.fetchValidateLogin = this.fetchValidateLogin.bind(this);
    this.fetchtMessagesDestinatario = this.fetchtMessagesDestinatario.bind(this);
    this.handlerSendMessage = this.handlerSendMessage.bind(this);
    this.fetchtMessages = this.fetchtMessages.bind(this);
    this.onChangeMessages = this.onChangeMessages.bind(this);
    this.setPerson = this.setPerson.bind(this);
    this.handleOpenMessage = this.handleOpenMessage.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.setPersonForum = this.setPersonForum.bind(this);
    this.getMessagesForum = this.getMessagesForum.bind(this);
    this.openForum = this.openForum.bind(this);
  }

  async fetchtMessagesDestinatario() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
   var response;
    if (this.context.usr_type.replace(/\//g, "") === "parents") {
       response = await getDocList(this.context.per_std);
    }
    else{
       response = await getDocList(this.context.per_id);  
    }
    var teacher = [];
    var hashTeacher = {};
    teacher = response.filter((o) => (hashTeacher[o.per_id] || o.per_id === null ? false : (hashTeacher[o.per_id] = true)));
    this.setState({ dataPerson: teacher, loading: false });
  }

  async fetchtMessages(per_id:string) {
    if(validateTokenStorage()){
      this.context.quitToken();
    }

    const response = await getMessagesStudent(this.context.per_id + per_id,this.context.per_id);
    this.setState({ dataMessages: response, loading: false });
    scroll.scrollToBottom({
      containerId: "scrollContainer",
    });
    this.fetchtMessagesDestinatario();
  }


  async fetchValidateLogin() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    if (this.context.usr_type.replace(/\//g, "") === "parents") {
      const response = await validateLogin(this.context.per_id, this.context.usr_type.replace(/\//g, ""));
      if (response.inactivo) {
        this.context.quitToken();
      }  
    }
    else{
      const response = await validateLogin(this.context.per_id,this.context.usr_type.replace(/\//g, ""));
      if(response.inactivo){
        this.context.quitToken()
      }    
    }
  }

  componentDidMount() {
    this.fetchtMessagesDestinatario();
    this.fetchValidateLogin();
  }

  handlerSendMessage() {

    if(validateTokenStorage()){
      this.context.quitToken();
    }
    const props = this.state.formMessages;
    const propsdestinatario = this.state.personForm;

    if(this.state.isOpenForum){
      const body = {
        per_id: this.context.per_id,
        per_teacher:propsdestinatario.per_id,
        msg_person: this.context.per_id,
        msg_desc: props.msg_desc,
        msg_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        msg_foro:"1",
      };
      postMessagesForumStudent(body);
      setTimeout(() => {
        this.getMessagesForum({per_id:propsdestinatario.per_id});
      }, 1000);
    }
    else{
      const body = {
        msg_num: this.context.per_id + propsdestinatario.per_id,
        msg_person: this.context.per_id,
        msg_destinatario: propsdestinatario.per_id,
        msg_desc: props.msg_desc,
        msg_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        msg_foro:"0",
        msg_grade:"0"
      };
      postMessagesStudent(body);
      setTimeout(() => {
        this.fetchtMessages(propsdestinatario.per_id);
      }, 1000);
    }

    // const body = {
    //   msg_num: this.context.per_id + propsdestinatario.per_id,
    //   msg_person: this.context.per_id,
    //   msg_desc: props.msg_desc,
    //   msg_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    // };

    // postMessages(body);
    this.setState({
      loading: true,
      formMessages: {
        msg_remitente: "",
        msg_destinatario: "",
        msg_desc: "",
        msg_time: "",
      },
    });
    // setTimeout(() => {
    //   this.fetchtMessages(propsdestinatario.per_id);
    // }, 1000);
  }

  setPerson({ per_id, per_name }) {
    this.setState((prevState) => ({
      personForm: {
        per_id,
        per_name,
      },
      isOpenMessage: true,
    }));
    this.fetchtMessages(per_id);
  }

  async getMessagesForum({per_id}) {
    if(validateTokenStorage()){
      this.context.quitToken();
    }

    const response = await fetchtMessagesForumStudent(this.context.per_id,per_id);
    this.setState({ dataMessages: response, loading: false });
    scroll.scrollToBottom({
      containerId: "scrollContainer",
    });
  }

  openForum() {
this.setState({
  isOpenForum:true,
  isOpenMessage:false
})

  }
  setPersonForum({per_id,per_name}) {
    this.getMessagesForum({per_id});
    this.setState({
      personForm: {
        per_id,
        per_name:"FORO PROFESOR "+per_name,
        // +this.state.formGrade.gr_desc+" "+this.state.formGrade.gr_alias
      },
      isOpenForum:true,
      isOpenMessage: true
    })
  }

  onChangeMessages(e: any) {
    this.setState({
      formMessages: {
        ...this.state.formMessages,
        [e.target.name]: e.target.value,
      },
    });
  }

  handleOpenMessage() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.setState((prevState) => ({
      isOpenMessage: !prevState.isOpenMessage,
      isOpenForum:false
    }));
  }

  rechargeData() {
    const props = this.state.personForm;
    this.setState({ loading: true });
    if(this.state.isOpenForum){
      setTimeout(() => {
        this.getMessagesForum({per_id:props.per_id});
      }, 1000);
    }
    else{
      setTimeout(() => {
        this.fetchtMessages(props.per_id);
      }, 1000);
    }
  }


  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Row>
          <Col xs={12}>
            <MESSAGE_CHAT_CONTAINER
              per_id={this.context.per_id}
              props={props}
              handlerSendMessage={this.handlerSendMessage}
              onChangeMessage={this.onChangeMessages}
              setPerson={this.setPerson}
              openForum = {this.openForum}
              setPersonForum ={this.setPersonForum}
              isOpenMessage={props.isOpenMessage}
              handlerGoback={this.handleOpenMessage}
              reload= {this.rechargeData}
              isOpenForum ={props.isOpenForum}
            />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
export default Messages;
